import { render, staticRenderFns } from "./Step4ProductDetailRow.vue?vue&type=template&id=92f1cf8a"
import script from "./Step4ProductDetailRow.vue?vue&type=script&lang=js"
export * from "./Step4ProductDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports